import React, {Component} from 'react';
import marketStyle from '../css/marketsCricket.css';
import OddsCardCricket from './oddsCardCricket';
import {getText} from "../../../../../helpers/localization";

class FirstTeamWicketLost extends Component {

    render() {
        let store = this.props.store;
        let markets = this.props.markets;
        return (<div className={marketStyle.marketGroup}>
            <div className={marketStyle.scoreGroupMedium}>
                <div className={`${marketStyle.marketLabelMedium} ${marketStyle.marketLabel}`}>
                    <span>{getText(markets[0].selection, this.props.store)}</span>
                </div>
                <div className={marketStyle.oddsContainerMedium}>
                    <OddsCardCricket store={store} market={markets[0]}/>
                </div>
            </div>
            <div className={marketStyle.scoreGroupMedium}>
                <div className={`${marketStyle.marketLabelMedium} ${marketStyle.marketLabel}`}>
                    <span>{getText(markets[1].selection, this.props.store)}</span>
                </div>
                <div className={marketStyle.oddsContainerMedium}>
                    <OddsCardCricket store={store} market={markets[1]}/>
                </div>
            </div>
        </div>);
    }
}

export default FirstTeamWicketLost;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/cricket/components/firstTeamWicketLost.js